import React from 'react';
import CornerDateMarker from "../date-picker-calendar/CornerDateMarker";
import DisabledMarker from "../date-picker-calendar/DisabledDateMarker";
import OutlineDateMarker from "../date-picker-calendar/OutlineDateMarker";
import { DateMarkerType } from "../interfaces";
import { MARKER_EXAMPLE_SIZE } from "./constants";
import { MarkerExampleWrapper } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";

var MarkerExample = function MarkerExample(_ref) {
  var type = _ref.type;
  return type === DateMarkerType.Corner ? ___EmotionJSX(MarkerExampleWrapper, {
    role: "presentation"
  }, ___EmotionJSX(CornerDateMarker, {
    hasMarker: true,
    size: MARKER_EXAMPLE_SIZE
  })) : ___EmotionJSX("div", {
    role: "presentation"
  }, ___EmotionJSX(OutlineDateMarker, {
    type: type,
    size: MARKER_EXAMPLE_SIZE
  }));
};

MarkerExample.displayName = 'MarkerExample';

var DisabledMarkerExample = function DisabledMarkerExample() {
  return ___EmotionJSX(MarkerExampleWrapper, {
    role: "presentation"
  }, ___EmotionJSX(DisabledMarker, {
    isDisabled: true,
    wrapperWidth: MARKER_EXAMPLE_SIZE,
    wrapperHeight: MARKER_EXAMPLE_SIZE,
    markerWidth: MARKER_EXAMPLE_SIZE
  }));
};

DisabledMarkerExample.displayName = 'DisabledMarkerExample';
export { MarkerExample, DisabledMarkerExample };